/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useMemo} from 'react'
import {Column} from 'react-table'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useCentral} from '../../../../../../hooks/useCentral'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {TabCentralModel} from '../../../../../../models'
import {useApplication, useClient, useCompany, useSite} from '../../../../hooks'
import {RangeParamDocument} from '../../../../model'
import {getRangeParamsTable} from '../../../../services'
const TableRangeParam: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    clearSelected,
    pagination,
    updateTable,
    setUpdateTable,
    selectedOn,
    clearTable,
    setClearTable,
  } = useKTable()
  const {currentTabItem, changeCurrentTabItem} = useCentral()
  const {searchValues, clearSearchValues} = useKhipu()
  const {companyList, getCompanyList} = useCompany()
  const {clientList, getClientList} = useClient()
  const {siteList, getSiteList} = useSite()
  const {module, getModuleList} = useApplication()

  const getRangeParamsList = async () => {
    try {
      setLoading(true)
      const {data: response} = await await getRangeParamsTable({
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
        ...searchValues,
      })
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    getRangeParamsList()
    getCompanyList()
    getClientList()
    getSiteList()
    getModuleList()
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    if (Object.keys(searchValues).length === 0) {
      getRangeParamsList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValues])
  useEffect(() => {
    getRangeParamsList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  const handleViewPanel = (data: RangeParamDocument) => {
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: true,
      content: {
        ...currentTabItem.content,
        detailPanel: 'form-range-params',
      },
      idToEdit: data.Id as string,
      idToDelete: '',
    }
    changeCurrentTabItem(obj)
    clearSelected()
  }

  const columns: Column<RangeParamDocument>[] = useMemo(
    () => [
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Compañía'
            name={'CompaniaId'}
            data={companyList}
            selecteable
          />
        ),
        accessor: 'Compania_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cliente'
            name={'ClienteId'}
            data={clientList}
            selecteable
          />
        ),
        accessor: 'Cliente_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Site'
            name={'SiteId'}
            data={siteList}
            selecteable
          />
        ),
        accessor: 'Site_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Módulo'
            name={'AplicacionId'}
            data={module}
            selecteable
          />
        ),
        accessor: 'Aplicacion_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Código' name={'Codigo'} searcheable />
        ),
        accessor: 'Codigo',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) => (
          <>
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleViewPanel(props.row.original)}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          </>
        ),
      },
    ],
    [companyList, clientList, siteList, module, selectedOn],
  )

  useEffect(() => {
    setInitialPagination()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.loadingTable])

  const setInitialPagination = async () => {
    try {
      const {data: response} = await getRangeParamsTable({
        pageNumber: 1,
        size: 10,
      })
      setPagination({
        perPage: 10,
        currentPage: 1,
        totalResults: response.total,
      })
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {
    if (currentTabItem.loadingTable) {
      clearSelected()
      getRangeParamsList()
      changeCurrentTabItem({...currentTabItem, loadingTable: false})
    }
  }, [currentTabItem.loadingTable])
  useEffect(() => {
    if (updateTable) {
      clearSelected()
      getRangeParamsList()
      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])
  useEffect(() => {
    if (clearTable) {
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])
  return (
    <KTCard shadow className='mx-2  w-100'>
      <KTable data={data} columns={columns as any} classNameProps='dataTablecentral' />
      {loading ? <KTableLoading title='Cargando...' /> : null}
    </KTCard>
  )
}

const TableRangeParamWrapper = () => {
  return (
    <KTableProvider>
      <TableRangeParam />
    </KTableProvider>
  )
}

export {TableRangeParamWrapper}
